import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import api from "../lib/api";
import BottomNav from "./BottomNav";
import TopBar from "./TopBar";
import NotificationPrompt from "./NotificationPrompt";
import GoldlyReward, { showGoldlyReward } from "./GoldlyReward";
import SupportChatWidget from "./SupportChatWidget";
import PWAInstallPrompt from "./PWAInstallPrompt";
import JackpotBroadcast from "./JackpotBroadcast";

function useActivityHeartbeat() {
  useEffect(() => {
    // Skip when no auth token (not logged in)
    const tokenExists = () => !!localStorage.getItem("hf_token");
    let interval;
    const ping = () => {
      if (document.hidden || !tokenExists()) return;
      api.post("/me/heartbeat").then(r => {
        if (r.data?.awarded > 0) showGoldlyReward(r.data.awarded, "active_2h");
      }).catch(() => {});
    };
    // First ping after 60s, then every 60s while tab is visible
    interval = setInterval(ping, 60_000);
    return () => clearInterval(interval);
  }, []);
}

export default function MobileLayout({ hideTop = false, hideBottom = false, children }) {
  useActivityHeartbeat();
  return (
    <div className="min-h-screen bg-mesh">
      {/* Full viewport on tablet/desktop — reels feed needs the whole screen
          height for wheel/keyboard scroll to work correctly. Mobile keeps the
          natural max-w-md phone width. */}
      <div className="max-w-md md:max-w-none mx-auto min-h-screen relative">
        {!hideTop && <TopBar />}
        <main className={`${hideTop ? "" : "pt-16"} ${hideBottom ? "" : "pb-24"}`}>
          {children || <Outlet />}
        </main>
        {!hideBottom && <BottomNav />}
        <NotificationPrompt />
        <GoldlyReward />
        <SupportChatWidget />
        <PWAInstallPrompt />
        <JackpotBroadcast />
      </div>
    </div>
  );
}
